export function scrollToNext(event) {
  let currentSection = event.target.closest('section');
  let nextSection = currentSection?.nextElementSibling;

  setTimeout(() => {
    while (nextSection && nextSection.style.display === 'none') {
      nextSection = nextSection.nextElementSibling;
    }

    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  }, 50);
}

window.scrollToNext = scrollToNext;